module.exports = function (notification) {
  var tweetHtml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var icon = 'fa-bell';
  if (notification.type === 'like') {
    icon = 'fa-heart';
  } else if (notification.type === 'reply') {
    icon = 'fa-comment';
  } else if (notification.type === 'retweet' || notification.type === 'quote') {
    icon = 'fa-repeat';
  }
  return "\n    <article class=\"notification\" data-id=\"".concat(notification.signature, "\" data-tweet-id=\"").concat(notification.tweet_signature, "\">\n      <header class=\"meta\">\n        <span class=\"icon\" aria-hidden=\"true\">\n          <i class=\"fa-solid ").concat(icon, "\"></i>\n        </span>\n        <div class=\"summary\">\n          <span class=\"text\">").concat(notification.text, "</span>\n          <span class=\"time saito-userline\">").concat(notification.time, "</span>\n        </div>\n      </header>\n      <div class=\"slot\">\n        ").concat(tweetHtml, "\n      </div>\n    </article>\n  ");
};